import { render, staticRenderFns } from "./AgendaItemModal.vue?vue&type=template&id=7d0a7c02&"
import script from "./AgendaItemModal.vue?vue&type=script&lang=js&"
export * from "./AgendaItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d0a7c02')) {
      api.createRecord('7d0a7c02', component.options)
    } else {
      api.reload('7d0a7c02', component.options)
    }
    module.hot.accept("./AgendaItemModal.vue?vue&type=template&id=7d0a7c02&", function () {
      api.rerender('7d0a7c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/AgendaItemModal.vue"
export default component.exports